import Block from '../block'

export default class NavDropdown extends Block {
	static title = 'nav-dropdown'

	constructor($el) {
		super($el)

		this.toggle = this.$el.findElement('toggle')
		this.open = this.$el.findElement('toggle-open')
		this.close = this.$el.findElement('toggle-close')
		this.overlay = $('.nav-dropdown-overlay')

		this.toggle.on('click', () => {
			this.toggleNav()
		})

		this.overlay.on('click', () => {
			this.toggleNav()
		})

		$(document).on('keydown', (e) => {
			if (e.key === 'Escape' && this.$el.hasClass('nav-dropdown--active')) {
				this.toggleNav()
				this.toggle.get(0)?.focus()
			}
		})

		// A theme can give the fixed nav a background once content scrolls under it
		const setScrolled = () => {
			this.$el.toggleClass('nav-dropdown--scrolled', window.scrollY > 0)
		}

		window.addEventListener('scroll', setScrolled, { passive: true })
		setScrolled()

		$(document).on('product:add', (index, data) => {
			this.$el.findElement('count--span').text(data.count)
		})

		$(document).on('product:remove', (index, data) => {
			this.$el.findElement('count--span').text(data.count)
		})

		$(document).on('product:update', (index, data) => {
			this.$el.findElement('count--span').text(data.count)
		})
	}

	toggleNav() {
		this.$el.toggleClass('nav-dropdown--active')
		this.open.toggleClass('hidden')
		this.close.toggleClass('hidden')
		this.overlay.toggleClass('hidden')
		this.toggle.attr(
			'aria-expanded',
			this.$el.hasClass('nav-dropdown--active') ? 'true' : 'false',
		)
	}
}
